import React from 'react';

import type { FunctionComponent } from 'react';
import { differenceInDaysHandler, longDateHandler } from '@utils';

interface DisabledStatusProps {
	disabledOnUtc: string;
}

export const DisabledStatus: FunctionComponent<DisabledStatusProps> = ({ disabledOnUtc }) => {
	return (
		<div className="account-status-tooltip">
			{disabledOnUtc === null ? (
				<>
					<p className="account-status-content-row account-status-content-row--bold">
						Disabled on: <span className="account-status-content-row--normal">Unknown</span>
					</p>
				</>
			) : (
				<>
					<p className="account-status-content-row account-status-content-row--bold">Disabled on:</p>
					<p className="account-status-content-row">{longDateHandler(disabledOnUtc)}</p>
					<p className="account-status-content-row">{differenceInDaysHandler(disabledOnUtc)} days ago</p>
				</>
			)}
		</div>
	);
};
